import { Pill, type PillSize, type PillVariant } from "@clipboard-health/ui-components";

interface StripePillProps {
  size?: PillSize;
  variant?: PillVariant;
}

export function StripePill(props: StripePillProps) {
  const { size = "small", variant = "outlined" } = props;

  return (
    <Pill
      size={size}
      variant={variant}
      label="Setup Stripe"
      iconType="locked-filled"
      backgroundColor={(theme) => theme.palette.background.tertiary}
      outlineColor={(theme) => theme.palette.intent?.neutral.border}
      color={(theme) => theme.palette.intent?.neutral.text}
      iconColor={(theme) => theme.palette.intent?.neutral.icon}
      sx={{
        width: "fit-content",
      }}
    />
  );
}
